import { getWindowObject, HAS_WINDOW } from '@eventbrite/feature-detection';
import { Nullable } from '@eventbrite/ts-utils';

export const checkNewBillingSettingsEnabled = (): boolean => {
    if (!HAS_WINDOW) {
        return false;
    }

    const serverData = getWindowObject('__SERVER_DATA__');
    const { launchNewBillingSettings } = serverData?.featureFlags || {};

    if (launchNewBillingSettings === undefined) {
        const path = window?.location?.pathname;
        window?.dataLayer?.push({
            event: 'track',
            eventName: 'FF-launchNewBillingSettings-missing',
            eventData: { path, host: window.location.host },
            sendToHeap: true,
        });
        return false;
    } else {
        return launchNewBillingSettings;
    }
};

export function getOldOrNewFeature<T, U>(oldFeature: T, newFeature: U): T | U;
export function getOldOrNewFeature<T>(oldFeature: T): T | null;
export function getOldOrNewFeature<T, U>(
    oldFeature: T,
    newFeature?: U,
): Nullable<T | U> {
    const _newFeature = newFeature || null;
    const newBillingSettingsEnabled = checkNewBillingSettingsEnabled();
    return newBillingSettingsEnabled ? _newFeature : oldFeature;
}
